import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div style={{ maxWidth: '52ch' }}>
      <p style={{ font: 'var(--bmr-h2-weight, 500) var(--bmr-h2-size, 22px)/var(--bmr-h2-leading, 1.3) var(--bmr-font-display)', letterSpacing: 'var(--bmr-h2-tracking, normal)', margin: 0 }}>
        Cette page n’existe pas.
      </p>
      <p style={{ margin: '10px 0 0', color: 'var(--bmr-text-body)', fontSize: 13.5 }}>
        L’adresse a peut-être changé. Rien n’a été perdu.
      </p>
      <p style={{ marginTop: 14 }}>
        <Link to="/" style={{ color: 'var(--bmr-action)' }}>Retour à l’accueil</Link>
      </p>
    </div>
  )
}
